import React, { useContext } from 'react'
import { FormContext } from '../index'
import GenericFlatButton from '../../GenericFlatButton'

const GenericSubmitButton = props => {
  const form = useContext(FormContext)

  const onClick = e => {
    form && form.submit && form.submit(e, form)
    props.onClick && props.onClick(e, form)
  }

  return (
    <GenericFlatButton
      loading={props.formSubmitting}
      type={'filled'}
      title={'Submit'}
      {...props}
      onClick={onClick}
    />
  )
}
export default GenericSubmitButton
